module.exports = __webpack_public_path__ + "html/block-text.component.html";